import AddPersonalInformation from './AddPersonalInformation';

export default AddPersonalInformation;
